import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-kpi-card',
  imports: [],
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.scss'
})
export class KpiCardComponent {
  @Input() icon = '';
  @Input() iconBg = '';
  @Input() iconColor = '';
  @Input() label = '';
  @Input() value = '';
  @Input() change = '';
}
